import { useEffect, useState } from 'react'
import { UploadOutlined } from '@ant-design/icons';
import { Button, Upload } from 'antd';
import { addFileToStore } from 'Services/WeaverUtils'
import moment from 'moment';

const InlineUploadFileInput = ({ save, value, onChange, ...props }) => {
  const [uploading, setUploading] = useState(false)
  const [initting, setInniting] = useState(true)
  const [defaultFileList, setDefaultFileList] = useState([])
  const [wvrFileId, setWvrFileId] = useState(null)

  useEffect(() => {
    (async () => {
      setInniting(true)
      const files = await Weaver.File.list()
      const antFiles = files.map(convertToAnt)
      setDefaultFileList(antFiles.filter((file) => file.uid === value))
      setInniting(false)
    })()
  }, [])

  const parseChangedValue = ({ file, fileList }) => {
    fileList[0].wvrFileId = wvrFileId
    file.wvrFileId = wvrFileId
    return onChange({ file, fileList })
  }

  const convertToAnt = (wvrFile) => {
    return {
      name: wvrFile.name(),
      originFileObj: {
        uid: wvrFile.id(),
      },
      uid: wvrFile.id(),
      size: wvrFile.fileSize
    }
  }

  const createWeaverFile = async (file) => {
    try {
      file.uploadTime = moment()
      const wvrFile = new Weaver.File(file)
      await wvrFile.upload()
      setWvrFileId(wvrFile.id())
      addFileToStore(wvrFile)
    } catch (e) {
      console.error(e.message)
    }
  }

  if (initting) {
    return <div>Loading...</div>
  } else {
    return (
      <Upload
        style={{ width: '100%' }}
        action={null}
        beforeUpload={async (file) => {
          setUploading(true)
          await createWeaverFile(file)
          setUploading(false)
          return false
        }}
        showUploadList={{
          showPreviewIcon: false,
          showRemoveIcon: false,
          showDownloadIcon: false,
          removeIcon: false,
          downloadIcon: false
        }}
        maxCount={1}
        multiple={false}
        defaultFileList={defaultFileList}
        onChange={parseChangedValue}
        {...props}
      >
        <Button
          style={{ width: '100%' }}
          icon={<UploadOutlined />}
          disabled={uploading}
        >
          { uploading ? 'Uploading file. Please wait...' : 'Click to upload file' }
        </Button>
      </Upload>
    )
  }
}

export default InlineUploadFileInput
